import type { ServiceWorkQueue } from "@/lib/service/types";

/** Seed roster labels — unchanged from pilot DDL (`docs/sql/seed_service_pilot.sql`). */
export const SERVICE_SEED_JOB_TYPE_LABELS = [
  "Repair",
  "Warranty service",
  "New service",
  "Internal upgrade",
] as const;

export const SERVICE_SEED_JOB_TYPE_SLUGS = [
  "repair",
  "warranty",
  "new_service",
  "internal_upgrade",
] as const;

export const NEW_SERVICE_JOB_TYPE_SLUG = "new_service";

export function isSeedJobTypeSlug(slug: string): boolean {
  return (SERVICE_SEED_JOB_TYPE_SLUGS as readonly string[]).includes(slug);
}

/** True when every active queue is one of the four seed job types (custom adds allowed). */
export function rosterIsSeedOnly(queues: ServiceWorkQueue[]): boolean {
  if (queues.length === 0) return true;
  return queues.every((q) => isSeedJobTypeSlug(q.slug));
}

export function newServiceJobTypeQueueId(queues: ServiceWorkQueue[]): string {
  return queues.find((q) => q.slug === NEW_SERVICE_JOB_TYPE_SLUG && q.is_active)?.id ?? "";
}
